// Module
var code = `<template class="overview-aggregation-component">
  <require from="./overview-aggregation-component.scss"></require>
  <mdc-icon if.bind="params.state.allowSelection" class="ag-status-name-value ag-status-panel" click.trigger="selectFields()">settings</mdc-icon>
  <div repeat.for="f of params.state.fields" if.bind="f.show" class="ag-status-name-value ag-status-panel">
    <span class="ag-status-name-value__header">\${f.header}:</span>&nbsp;<span class="ag-status-name-value-value">\${f.value |
      numericFormatter:'0,0'}</span>
  </div>
</template>
`;
// Exports
export default code;